import React, { useState } from 'react'
import PrimaryModal from '../../UI/Modal/PrimaryModal';
import Loader from '../../UI/Loader/Loader';
import SuccessAlert from '../../UI/Alert/SuccessAlert';
import { SaveTaskFormSchema } from '../../../schemas';
import { Form, Formik } from 'formik';
import { FormikInput, PrimaryButton, SecondaryButton } from "../../UI";
import { useUserContext } from '../../../contexts/UserContext';
import { useLocation } from 'react-router-dom';
import { saveTask } from '../../../utils/APIs';
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const SaveTaskModal = ({ feature_id, campaignId }) => {
    const { content } = useContentfulContext();

    const [showModal, setShowModal] = useState(false)
    const [saveLoading, setSaveLoading] = useState(false);
    const [saveError, setSaveError] = useState();
    const [showSuccess, setShowSuccess] = useState("");
    const { userData } = useUserContext();
    const { pathname, state } = useLocation();

    const handleSave = async (values) => {
        try {
            setSaveLoading(true);
            setSaveError("");
            const data = {
                feature_id,
                saved_task_name: values.name,
                function_id: pathname.split('/').pop(),
                adobe_io_integration_id: userData?.defaultAdobeIO?._id,
            };
            if(campaignId){
                data.campaign_id = campaignId
            }
            const result = await saveTask(
                userData.token,
                userData.selectedOrganization.org_token,
                data
            );
            setShowSuccess(result.message);
            setShowModal(false);
        } catch (error) {
            setSaveError(error?.message || content?.COMMON_MESSAGE.something_wrong_msg);
        } finally {
            setSaveLoading(false);
        }
    };

  return (
    <>
        {!state?.tenant_name && <SecondaryButton id="save-task-button" handleClick={() => setShowModal(true)}>
            {content.SAVE_TASK_MODAL_CONTENT.save_btn}
          </SecondaryButton>}
        {showSuccess && <SuccessAlert disappearTime={content.SAVE_TASK_MODAL_CONTENT.success_save_timeout} >{showSuccess}</SuccessAlert> }
        {saveLoading && <Loader />}
        {showModal && (
            <PrimaryModal title={content.SAVE_TASK_MODAL_CONTENT.title} hideModal={() => setShowModal(false)}>
                <div className='p-6 space-y-6'>
                <h1 className="text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl">{content.SAVE_TASK_MODAL_CONTENT.description}</h1>
                <Formik
                    initialValues={{
                        name: '',
                    }}
                    validationSchema={() => SaveTaskFormSchema(content.SAVE_TASK_MODAL_CONTENT)}
                    onSubmit={handleSave}
                >
                    {() => (
                        <Form className="space-y-4 md:space-y-6" action="#" id="registration-form">
                            <FormikInput
                                type="text"
                                id="name"
                                name="name"
                                label={content.SAVE_TASK_MODAL_CONTENT.formLabels.name}
                            />
                            {saveError && <p className="mt-2 text-sm text-red-5">{saveError}</p>}
                            <div className="flex items-center justify-end space-x-2">
                                <PrimaryButton id="save-task" type="submit">{ content.SAVE_TASK_MODAL_CONTENT.save_btn }</PrimaryButton>
                            </div>
                        </Form>
                    )}
                </Formik>
                </div>
            </PrimaryModal>
        )}
    </>
  )
}

export default SaveTaskModal